import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getServiceLocations(params: any): AxiosPromise {
    return EndPointService.get('/service_locations', { params });
}

function getServiceLocation(id: number | string): AxiosPromise {
    return EndPointService.get(`/service_locations/${id}`);
}

function deleteServiceLocation(id: number | string): AxiosPromise {
    return EndPointService.delete(`/service_locations/${id}`);
}

function createServiceLocation(payload: any): AxiosPromise {
    return EndPointService.post('/service_locations', payload);
}

function updateServiceLocation(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/service_locations/${id}`, payload);
}

export default {
    getServiceLocations,
    getServiceLocation,
    deleteServiceLocation,
    createServiceLocation,
    updateServiceLocation,
};
